<template>
    <v-container fluid class="container-full-bg-gray">
        <v-dialog v-model="screen_data.delete_pop_up" persistent max-width="500">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Eliminar registros</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se eliminarán permanentemente  {{ screen_data.selectedItems.length.toString() }} elemento(s)
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.delete_pop_up = false" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="deleteEntityInstances"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="screen_data.download_pop_up" persistent max-width="500">
            <v-card>
                <v-card-title>
                    <span class="primary_blue--text">Descargar registros</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <p class="text-subtitle-1 mt-4">
                        Se descargarán  {{ screen_data.selectedItems.length.toString() }} elemento(s)
                    </p>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.download_pop_up = false" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        @click="downloadEntityInstances"
                    >
                    Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
 
        <v-row class="mb-2 pl-4">
            <v-col cols="3" class="d-flex align-center">
                <v-select
                    v-model="screen_data.selectedType"
                    :items="screen_data.types"
                    label="Tipo de Registro"
                    item-text="name"
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    @change="changedType">  
                </v-select>
                <v-tooltip top v-if="screen_data.selectedType && im_staff_or_loginas">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            color="primary_blue"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="$router.push({name: 'entity-type-editor', params: { companydb_id: companydb_id, entity_type_id: screen_data.selectedType.uuid}});">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar Tipo</span>
                </v-tooltip>
                <v-tooltip top v-if="screen_data.selectedType && im_staff_or_loginas">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            color="primary_blue"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="copy_current_type_explicit_schema">
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                    </template>
                    <span>Copiar Esquema</span>
                </v-tooltip>
                <v-tooltip top v-if="im_staff_or_loginas">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            color="primary_blue"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="$router.push({name: 'entity-type-editor', params: { companydb_id: companydb_id, entity_type_id: null}});"
                            >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Añadir Tipo</span>
                </v-tooltip>
            </v-col>
            <v-col cols="9" v-if="screen_data.selectedType">
                <app-search-bar
                    class="ma-0"
                    :filters="computed_available_filters"
                    @updateObject="updateFilter"
                    @addFilter="addFilter"
                    :show_delete_filters="false"
                />
            </v-col>
            
        </v-row>
        

        <app-row v-if="screen_data.selectedType">
            <app-col cols="12">
                <v-card width="100%" class="rounded-lg">
                    <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
                        
                        <v-row class="pa-0 ma-0">
                            <v-col cols="6" class="pa-0 ma-0"> 
                                <span class="primary_blue--text"> Tus registros tipo {{screen_data.selectedType.name}} </span>
                            </v-col>
                            <v-col cols="6" class="pa-0 ma-0">
                                <slot>
                                    <div class="d-flex justify-end" align="right">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    @click="copy_selection_as_json_to_clipboard"
                                                    icon
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="screen_data.selectedItems == 0">
                                                    <v-icon>mdi-content-copy</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Copiar JSON selección</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    @click="screen_data.download_pop_up = true"
                                                    icon
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="screen_data.selectedItems == 0"
                                                    :loading="screen_data.loadingDownload">
                                                    <v-icon>mdi-download</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Descargar</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="fetchInstances" color="primary" icon v-bind="attrs" v-on="on"
                                                    :loading="screen_data.loadingItems">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Actualizar</span>
                                        </v-tooltip>
                                        
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn @click="newEntityInstance" color="primary"
                                                icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Añadir {{screen_data.selectedType.name}}</span>
                                        </v-tooltip>
                                        
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    @click="screen_data.delete_pop_up = true"
                                                    color="error"
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="screen_data.selectedItems == 0"
                                                    :loading="screen_data.loadingDelete">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Borrar</span>
                                        </v-tooltip>
                                        
                                    </div>
                                </slot>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                        <v-data-table
                            v-model="screen_data.selectedItems"
                            :items="screen_data.instances"
                            :headers="computed_headers"
                            :footer-items-per-page-text="screen_data.footerItemsPerPageText"
                            :footer-items-per-page-options="screen_data.footerItemsPerPageOptions"
                            :loading="screen_data.loadingItems"
                            :no-data-text="screen_data.textNoResults"
                            :loading-text="screen_data.textLoading"
                            fixed-header
                            :item-key="screen_data.itemKey"
                            :show-select="screen_data.showSelect"
                            @click:row="selectRow">
                             <!-- Custom Slot for Dynamic Headers -->
                             <template v-for="header in computed_headers" v-slot:[`header.${header.value}`]="{ header }">
                                <span tabindex="0">
                                    {{ header.text }}
                                </span>
                            </template>
                            <template v-for="header in computed_headers" v-slot:[`item.${header.value}`]="{ item }">
                                <span class="font-color">
                                    <slot v-if="header.value.includes('__')" v-bind="item" :name="header.value">
                                        {{ item[header.value.split('__')[0]][header.value.split('__')[1]]  }} <!-- Ensure this reflects the correct data property -->
                                    </slot>
                                    <slot v-else v-bind="item" :name="header.value">
                                        {{ item[header.value] }} <!-- Ensure this reflects the correct data property -->
                                    </slot>
                                </span>
                            </template>
            
                            <!-- Footer: Pagination -->
                            <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </app-col>
            
        </app-row>

    </v-container>
    
</template>
  
<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { EntityTypeApiRepository,  EntityInstanceApiRepository} from "@/modules/entities/infra/EntitiesApiRepositories";
import { EntitiesListScreenData} from "@/modules/entities/domain/EntitiesListScreenData";
import { EntitiesListComponent } from "@/modules/entities/app/EntitiesListComponent";
import { mapGetters, mapState } from "vuex";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import { filter } from "mathjs";
import { document_components_factory } from "@/api/client";
import { copy_to_clipboard } from "@/modules/shared/infra/ClipboardUtils";

  
export default {
    name: "EntitiesList",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        AppSearchBar,
    },
    data() {
        const component = document_components_factory.get_or_create_entities_list_component();
        return {
            screen_data: component.screen_data,
            entities_list_component: component,
            current_filters_names : []
            
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        }
    },
    watch: { 
        companydb_id: function() {
            this.entities_list_component.reset_company_id(this.companydb_id);
            this.entities_list_component.fetchInstances()
        }
    },
    computed: {
        ...mapState(['search_state', 'tags', 'currentCompany', 'session_information']),
        ...mapGetters({
            userData: 'me/userData',
        }),
        computed_headers() {
            return this.entities_list_component.get_entity_type_headers();
        },
        im_staff_or_loginas() {
            return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
        },
        computed_available_filters() {
            if (!this.screen_data.availableFilters) {
                return {}
            }
            // let current_filters_list = this.screen_data.filters.map((filter) => filter.filter)
            let available_filters = {}
            for(let key of Object.keys(this.screen_data.availableFilters)){
                let filter = this.screen_data.availableFilters[key]
                if (!this.current_filters_names.includes(filter.name) ){
                    available_filters[key] = filter
                }
            }
            return available_filters
        }
    },
    methods: {
        async changedType(){
            this.screen_data.selectedItems = []
            await this.entities_list_component.fetchInstances();
        },
        async updateFilter(params){
            console.log('updateFilter', params)
            //screen_data filter adequat
            let filter = params.key
            let value = params.value
            console.log('filter', filter)
            console.log('value', value)
            let existed = false

            if (params.value === ''){
                this.current_filters_names = this.current_filters_names.filter((name) => name !== filter)
            }

            for (let i in this.screen_data.filters) {
                let curr_filter = this.screen_data.filters[i]
                if (curr_filter.filter === params.key) {
                    curr_filter.value = params.value
                    if (params.value === ''){ //problema: quan es false també entra
                        this.screen_data.filters.splice(i, 1)
                        
                    }
                    existed = true
                }
            }
            if (!existed && value !== ''){
                this.screen_data.filters.push( {'filter': filter, 'value': value})
            }
            //fetch instances
            this.fetchInstances();
        },
        addFilter(filter){
            console.log('addFilter', filter)
            let name = filter.name
            this.current_filters_names.push(name)
        },


        async fetchInstances() {
            this.entities_list_component.fetchInstances();
        },
        formatField(value) {
            return value;
        },
        go_to_entity_instance_editor(entity_instance_id, entity_type_id) {
            this.$router.push({ name: 'entity-instance-editor', params: { entity_instance_id: entity_instance_id, entity_type_id: entity_type_id } });
        },
        selectRow(item) {
            this.go_to_entity_instance_editor(item.uuid, item.entity_type_id);
        },
        newEntityInstance(){
            this.go_to_entity_instance_editor(null, this.screen_data.selectedType.uuid);
        },
        deleteEntityInstances(){
            this.entities_list_component.delete_instances();
        },
        downloadEntityInstances(){
            this.entities_list_component.download_instances();
        },
        copy_current_type_explicit_schema() {
            copy_to_clipboard(this.screen_data.selectedType.schema);
        },
        copy_selection_as_json_to_clipboard(){
            let data_to_copy = []
            if (this.screen_data.selectedItems.length == 1){
                data_to_copy = this.screen_data.selectedItems[0].payload
            } else {
                data_to_copy = this.screen_data.selectedItems.map((item) => item.payload)
            }
            copy_to_clipboard(data_to_copy);
        }
    },
    async mounted() {
        this.entities_list_component.reset_company_id(this.companydb_id);
        this.entities_list_component.fetchTypes(this.im_staff_or_loginas);
    },
  
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
/*.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}*/

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}
</style>
  